import { useState, useEffect, useMemo } from 'react';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { Box } from '../../Box';
import listDefaultStyle from './listDefaultStyle';
import { nanoid } from 'nanoid';
import { clsx } from 'clsx';
import { ListItemContainer } from '../ListItem/ListItemContainer';
import { ListContext } from './ListContext';
import { jsx as _jsx } from "react/jsx-runtime";
const handleChildClick = (value, setSelected, onClick) => () => {
  if (onClick) {
    onClick();
  }
  setSelected(value);
};
export const List = props => {
  const {
    children,
    className,
    id,
    defaultSelected,
    selected,
    square = false,
    sx,
    selectable,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const listStyle = mergeSxStyle(listDefaultStyle(theme, square), sx);
  const [_selected, setSelected] = useState(defaultSelected === undefined ? -1 : defaultSelected);
  useEffect(() => {
    if (selected !== undefined) {
      setSelected(selected);
    }
  }, [selected]);
  const listItemsChildren = useMemo(() => {
    const _children = Array.isArray(children) ? children : [children];
    return _children.reduce((acc, child, index) => {
      if (!child) {
        return acc;
      }
      acc.push( /*#__PURE__*/_jsx(ListItemContainer, {
        onClick: handleChildClick(id || index, setSelected, child.props.onClick),
        selectable: selectable,
        index: index,
        id: child.props.id,
        sx: child.props.sx,
        children: child
      }, nanoid()));
      return acc;
    }, []);
  }, [children, selectable]);
  return /*#__PURE__*/_jsx(ListContext.Provider, {
    value: _selected,
    children: /*#__PURE__*/_jsx(Box, {
      className: clsx(['ids-list-root', className]),
      id: id,
      component: "div",
      "data-testid": rest['data-testid'],
      sx: listStyle,
      children: /*#__PURE__*/_jsx(Box, {
        className: "ids-list-items-container",
        component: "div",
        id: 'ids-list-items-container',
        children: listItemsChildren
      })
    })
  });
};
List.displayName = 'List';